// frontend/src/index.jsx  (או index.js)
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18n/i18n";
import { AuthProvider } from "./auth/AuthContext";

// Load global styles
import "./index.css";
import "./App.css";
import "./styles/intake.css";
import "./styles/chat.css";
import "./styles/voicechat.css";
import "./designSystem.css";
import "./mobile-app.css";

const rootEl = document.getElementById("root");
const root = createRoot(rootEl);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
